import { createAction } from '@ngrx/store';

/** Existing actions (unchanged) */
export const toggleSidebar = createAction('[Sidebar] Toggle');
export const expandSidebar = createAction('[Sidebar] Expand');
export const collapseSidebar = createAction('[Sidebar] Collapse');

/** New actions */
export const hideSidebar = createAction('[Sidebar] Hide');
// export const showSidebar = createAction('[Sidebar] Show');
export const restoreSidebarVisibility = createAction('[Sidebar] Restore Visibility')